/** Paleta dos estágios de produção — a mesma no kanban (onde se gerencia a coluna) e no atalho
 *  "Novo estágio" da planilha, pra um estágio nascer com a mesma cara nos dois lugares. */
export const STAGE_COLORS = ["#2457ff", "#0ea5e9", "#f59e0b", "#22c55e", "#f43f5e", "#78716c"];

export const ehCorEscolhidaAmao = (hex: string | null | undefined) =>
  !!hex && !STAGE_COLORS.includes(hex.toLowerCase());

/** Luminância relativa (WCAG). 0 = preto, 1 = branco. */
function luminancia(hex: string): number {
  const n = hex.replace("#", "");
  const canal = (i: number) => {
    const v = parseInt(n.slice(i * 2, i * 2 + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * canal(0) + 0.7152 * canal(1) + 0.0722 * canal(2);
}

/**
 * Escurece a cor até ela servir como TEXTO.
 *
 * A cor do estágio é usada duas vezes no mesmo rótulo: fundo em 10% de opacidade e texto em 100%.
 * Isso funciona pra cor média ou escura e falha pra cor clara — amarelo-claro escolhido à mão vira
 * texto quase branco sobre fundo quase branco. Em vez de espalhar a correção pelas oito telas que
 * desenham a etiqueta, ela acontece na ESCOLHA: o que é gravado já é legível.
 *
 * O alvo (0.35) é empírico, não normativo: é onde a cor ainda é reconhecível como a que a pessoa
 * escolheu e já passa com folga sobre o fundo claro do rótulo. Escurece em passos multiplicativos
 * pra preservar o matiz — não é converter pra cinza, é a mesma cor, mais fechada.
 */
export function ajustarParaLeitura(hex: string): string {
  if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) return STAGE_COLORS[0];
  let [r, g, b] = [0, 1, 2].map((i) => parseInt(hex.slice(1 + i * 2, 3 + i * 2), 16));

  // Teto de 12 passos: 0.85^12 ≈ 0.14, escurece o suficiente pra qualquer cor de partida e o laço
  // nunca fica preso numa cor que não desce (preto puro já sai no primeiro teste).
  for (let i = 0; i < 12 && luminancia(rgbParaHex(r, g, b)) > 0.35; i++) {
    [r, g, b] = [r, g, b].map((c) => Math.round(c * 0.85));
  }
  return rgbParaHex(r, g, b);
}

function rgbParaHex(r: number, g: number, b: number): string {
  return `#${[r, g, b].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
}
